import(/* webpackMode: "eager" */ "/var/www/apect/src/app/forums/[category]/[slug]/page.tsx");
